import { render, staticRenderFns } from "./Underlyings.vue?vue&type=template&id=74833350&scoped=true&"
import script from "./Underlyings.vue?vue&type=script&lang=js&"
export * from "./Underlyings.vue?vue&type=script&lang=js&"
import style0 from "./Underlyings.vue?vue&type=style&index=0&id=74833350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74833350",
  null
  
)

export default component.exports